// 卡片狀態與樣式的純判斷。刻意不 import antd/axios，測試才跑得動
// (慣例同 navigation.test.js 與 inventoryData.test.js)。

// AI 是加值而非前提：no-feedback 與 not-generated 意義相反，不可混為一談。
// error 則是第三種：讀取失敗時絕不能顯示成「沒有回饋」那種好消息文案。
export function cardState(data, error) {
  if (error) return "error";
  if (!data) return "loading";
  if (!data.item_count) return "no-feedback";
  if (!data.summary) return "not-generated";
  return "ready";
}

const STALE_HOURS = 36;

// 排程掛掉時畫面不該安靜地顯示過期內容。
export function isStale(generatedAt, now = new Date()) {
  if (!generatedAt) return false;
  return (now - new Date(generatedAt)) / 36e5 > STALE_HOURS;
}

const SEVERITY = {
  high: { color: "red", label: "警示" },
  medium: { color: "orange", label: "關注" },
  low: { color: "blue", label: "參考" },
};

export function severityTag(severity) {
  return SEVERITY[severity] || SEVERITY.low;
}

/**
 * 一則亮點／問題的出處標籤。
 *
 * 只在兩個來源都有時給數字 —— 那時數字帶的是「來源比例」這個 popover 看不到的
 * 資訊。單一來源時數字就等於旁邊那顆「[N 則]」佐證按鈕的筆數，兩個相像的數字
 * 緊鄰並排 (實測線上站每一項都是 `SC 32 [32 則]` 這種樣子)，讀者無從分辨它們
 * 是不是同一件事。筆數歸 popover，這裡只講出處。
 *
 * 單一來源用全名而非 SC／G：線上站目前全數來自 SurveyCake，混合分支幾乎不會
 * 出現，縮寫沒有機會被學會；全名也與明細抽屜的既有寫法一致。
 */
export function sourceLabel(sources) {
  if (!sources) return "";
  const sc = sources.surveycake || 0;
  const g = sources.google || 0;
  if (sc && g) return `SC ${sc}・G ${g}`;
  if (sc) return "SurveyCake";
  if (g) return "Google";
  return "";
}
